import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Amplify, Auth } from "aws-amplify";
import { useRecoilState } from "recoil";
import { originalPathState } from "../global-state";
import { DEV_AUTH_CONFIG } from "../aws-config";

const DeveloperLoginCallback = () => {
  const history = useHistory();
  const [originalPath, setOriginalPath] = useRecoilState(originalPathState);

  useEffect(() => {
    const handleCallback = async () => {
      if (!history) {
        return;
      }

      const urlParams = new URLSearchParams(window.location.search);
      const state = urlParams.get("state");
      const path = state ? decodeURIComponent(state) : "/m/playground";
      try {
        Amplify.configure(DEV_AUTH_CONFIG);
        const session = await Auth.currentSession();
        const email = session.getIdToken().payload["email"];
        console.log(email);
        console.log(path);
        console.log(1111);
        history.push(path);
      } catch (error) {
        console.error("Error during callback handling", error);
        history.push("/developer-login");
      }
    };

    handleCallback();
  }, [history]);

  return (
    <div>
      <h1>Processing login...</h1>
    </div>
  );
};

export default DeveloperLoginCallback;
